(function(a,b){"object"==typeof exports&&"undefined"!=typeof module?b(require("lodash")):"function"==typeof define&&define.amd?define(["lodash"],b):b(a._)})(this,function(a){"use strict";function b(a){var b=function(){for(var c=[],d=arguments.length;d--;)c[d]=arguments[d];return a.call.apply(a,[this,b].concat(c))};return b}a=a&&a.hasOwnProperty("default")?a["default"]:a,a.mixin({product:function c(){for(var d=[],e=arguments.length;e--;)d[e]=arguments[e];var c=[];return b(function(b,e){e.length<d.length?a.forEach(d[e.length],function(c){b(a.concat(e,[c]))}):c.push(e)})([]),c}})});



//////////////////
// WEBPACK FOOTER
// ./~/lodash.product/lodash.product.js
// module id = 548
// module chunks = 0